export default {
  'system.title': 'ข้อกำหนดของระบบ',
  'system.required':
    'บริการนี้รองรับระบบปฏิบัติการดังต่อไปนี้<br />' +
    'iOS / iPadOS 14.1 ขึ้นไป<br />' +
    'Android 11 ขึ้นไป (ระบบปฏิบัติการดั้งเดิม)<br />' +
    '*อุปกรณ์ที่ใช้ระบบปฏิบัติการที่ปรับแต่งอาจไม่สามารถใช้งานได้',
} as Record<string, string>;
